<template>
    <section class="csv-upload">
        <Link :href="route('index.quickOrdering')" class="title-s csv-upload__backCta">Back to Quick Order</Link>
        <h1 class="headline-l">CSV Uploader</h1>
        <div class="csv-upload__content-wrapper">
            <div class="csv-upload__content-wrapper__form">
                <div class="drop-wrapper">
                <PrimeFileUpload
                        name="csv"
                        :customUpload="true"
                        accept="text/csv"
                        :maxFileSize="2000000"
                        :multiple="false"
                        :fileLimit="1"
                        ref="fileUpload"
                        :showCancelButton="false"
                        @select="onFileSelect"      
                    >
                    <template #header="{ chooseCallback, uploadCallback, clearCallback, files }" class="drop-header">
                        <UploadIcon alt="Upload csv file" />
                        <h3 class="title-l">Import UPC and Quantity CSV File</h3>
                        <span class="paragraph-default">Drag and drop or <a @click.prevent="chooseCallback()">browse</a> your files to get started</span>
                        <label for="file-input" class="upload-button" @click="onAdvancedUpload()" :disabled="!files || files.length === 0 || uploadForm.processing">UPLOAD FILE</label>
                    </template>

                    <template #empty class="drop-file-here-wrapper">
                        <div class="drop-file-here">
                        </div>
                    </template>
                     <template #content="{ files, uploadedFiles, removeUploadedFileCallback, removeFileCallback }">
                        <div class="uploaded-content">
                            <div v-if="files.length > 0">
                                <div class="uploaded-file-wrapper">
                                    <div v-for="(file, index) of files" :key="file.name + file.type + file.size" class="uploaded-file">
                                        <span class="filename">{{ file.name }}</span>
                                        <span icon="pi pi-times" title="Remove" @click="onRemoveTemplatingFile(file, removeFileCallback, index)" severity="danger" class="remove-file-btn">&#x2715;</span>
                                    </div>
                                </div>
                            </div>
                            <label class="autocheckout" v-if="allowAutoCheckout">
                                <PrimeCheckbox binary name="autocheckout" v-model="uploadForm.autocheckout" />
                                AutoCheckout
                            </label>
                        </div>
                    </template>
                </PrimeFileUpload>
                </div>
                <p class="file-upload-errors" v-if="errors">{{ errors }}</p>
            </div>
            <div class="csv-upload__content-wrapper__table">
                <div class="csv-table-example">
                    <p class="title-s">CSV File Format</p>
                    <img src="@images/csv_file_format.png" alt="CSV File Format">
                </div>
	            <CSVUploadHelp />
            </div>
        </div>
    </section>
</template>
<script setup lang="ts">
    import CSVUploadHelp from '@/components/CSVUploadHelp.vue'
    import { Link, usePage } from "@inertiajs/vue3";
    import { useForm } from '@inertiajs/vue3'
    import { ref, inject, computed } from 'vue';
    import UploadIcon from '@icons/upload-icon.svg';
    let route = inject("route");
    const uploadForm = useForm({
        csv: null,
        autocheckout: false
    })

    let allowAutoCheckout = computed(()=>{
        return usePage().props.allowAutoCheckout;
    })

    const errors = computed(() => {
        return uploadForm.errors.csv || usePage().props.errors.csv;
    })

    const fileupload = ref();

    const onRemoveTemplatingFile = (file, removeFileCallback, index) => {
        removeFileCallback(index);
    };

    const onFileSelect = (event) => {
        const file = event.files[0];
        uploadForm.csv = file;
    }

    const onAdvancedUpload = async () => {
        if(uploadForm.processing) return;
        uploadForm.post(route('csv-upload.preview'))
    };

</script>
